import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import ProblemDetail from "../ProblemDetail/ProblemDetail";

const CoreErrorBoundary: React.FC<{
  children: React.ReactNode;
  onReset?: () => void;
  kind?: "default" | "small";
  onClose?: () => void;
}> = ({ children, kind = "default", onClose }) => {
  const logError = (error: Error, info: React.ErrorInfo) => {
    console.error("ErrorBoundary caught an error:", error, info);
  };
  return (
    <ErrorBoundary
      fallbackRender={(props) => (
        <ProblemDetail {...props} kind={kind} onClose={onClose} />
      )}
      onError={logError}
      onReset={() => {
        window.location.href = window.origin;
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export default CoreErrorBoundary;
